import { blog_topicConstants } from '../_constants';
import { blog_topicService } from '../_services';
import { alertActions } from '.';

export const blog_topicActions = {
  register,
  getById,
  getAll,
  update,
  delete: _delete
};

function getById(id) {

  return dispatch => {
    dispatch(request({ id }));

    blog_topicService.getById(id)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(id) { return { type: blog_topicConstants.GET_REQUEST, id } }
  function success(blogtopic) { return { type: blog_topicConstants.GET_SUCCESS, blogtopic } }
  function failure(error) { return { type: blog_topicConstants.GET_FAILURE, error } }
}

function register(blogtopic) {
  return dispatch => {
    dispatch(request(blogtopic));

    blog_topicService.register(blogtopic)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response));
            dispatch(alertActions.success('Registration topic successful'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(blogtopic) { return { type: blog_topicConstants.REGISTER_REQUEST, blogtopic } }
  function success(blogtopic) { return { type: blog_topicConstants.REGISTER_SUCCESS, blogtopic } }
  function failure(error) { return { type: blog_topicConstants.REGISTER_FAILURE, error } }
}

function update(blogtopic) {
  return dispatch => {
    dispatch(request(blogtopic));

    blog_topicService.update(blogtopic)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response));
            dispatch(alertActions.success('Updated topic successful'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(blogtopic) { return { type: blog_topicConstants.REGISTER_REQUEST, blogtopic } }
  function success(blogtopic) { return { type: blog_topicConstants.REGISTER_SUCCESS, blogtopic } }
  function failure(error) { return { type: blog_topicConstants.REGISTER_FAILURE, error } }
}

function getAll(api_params) {
  return dispatch => {
    dispatch(request());

    blog_topicService.getAll(api_params)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response))
          }
        }
      );
  };

  function request() { return { type: blog_topicConstants.GETALL_REQUEST } }
  function success(blogtopics) { return { type: blog_topicConstants.GETALL_SUCCESS, blogtopics } }
  function failure(error) { return { type: blog_topicConstants.GETALL_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    blog_topicService.delete(id)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(id));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(id, response));
          }
        }
      );
  };

  function request(id) { return { type: blog_topicConstants.DELETE_REQUEST, id } }
  function success(id) { return { type: blog_topicConstants.DELETE_SUCCESS, id } }
  function failure(id, error) { return { type: blog_topicConstants.DELETE_FAILURE, id, error } }
}
